import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, IconButton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';

function PointsCard() {
  const [pointsData, setPointsData] = useState(null);
  const [customerId, setCustomerId] = useState('');
  const [customerCode, setCustomerCode] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const localCustomerId = localStorage.getItem('customerId');
    const localCustomerCode = localStorage.getItem('customerCode');

    if (localCustomerId && localCustomerCode) {
      setCustomerId(localCustomerId);
      setCustomerCode(localCustomerCode);

      fetch('https://mfcapi.ykvario.com/smregiGetPoint.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerId: localCustomerId,
          customerCode: localCustomerCode,
        }),
      })
        .then((response) => response.json())
        .then((data) => setPointsData(data))
        .catch((error) => console.error('Error fetching points:', error));
    } else {
      console.warn('Customer ID or Code not found in localStorage');
    }
  }, []);

  const handleNavigate = () => {
    navigate('/account/barcode');
  };

  return (
    <Card
      onClick={handleNavigate}
      sx={{
        boxShadow: 3,
        borderRadius: 5,
        maxWidth: 600,
        margin: '0 auto',
        padding: '20px',
        position: 'relative',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <CardContent>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
          保有ポイント
        </Typography>
        {pointsData ? (
          <Box sx={{ position: 'relative' }}>
            <Typography variant="h1" component="div" sx={{ fontWeight: 'bold', fontSize: '4rem', display: 'inline-block' }}>
              {pointsData.point}
            </Typography>
            <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', display: 'inline-block', position: 'relative', top: '3px', left: '15px' }}>
              pt
            </Typography>
          </Box>
        ) : (
          <Typography variant="body2" align="center">ポイント情報を取得中...</Typography>
        )}
      </CardContent>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          handleNavigate();
        }}
        sx={{
          position: 'absolute',
          top: '50%',
          right: '20px',
          transform: 'translateY(-50%)',
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </Card>
  );
}

export default PointsCard;
